export function useProfileDropdown() {
  const isDropdownOpen = useState('dropdownOpen', () => false)

  const toggleDropdown = () => {
    isDropdownOpen.value = !isDropdownOpen.value
  }

  const closeDropdown = () => {
    isDropdownOpen.value = false
  }

  return {
    isDropdownOpen,
    toggleDropdown,
    closeDropdown,
  }
}
